import { useSuspenseQuery } from '@tanstack/react-query'

import { GetSimulacoesPorIds } from '@/features/simulador/services/get-simulacoes-por-ids.service'
import { simulacaoKeys } from '@/features/simulador/utils/queries'

export const useSuspenseSimulacoesPorIds = (simulacoesIds: string[]) => {
  return useSuspenseQuery({
    queryKey: simulacaoKeys.listaSimulacoesLancadas(simulacoesIds),
    queryFn: async () => new GetSimulacoesPorIds().execute(simulacoesIds).then((res) => res.data),
  })
}
